<div class="course-page">
  <div class="page-header">
    <div>
      <h1>Practice Courses</h1>
      <p>Read-only adoption and rollout visibility across organisations.</p>
    </div>
    <p-button
      label="Clear filters"
      icon="pi pi-filter-slash"
      [outlined]="true"
      (onClick)="clearFilters()"
    />
  </div>

  <p-card styleClass="filter-card">
    <div class="filters">
      <p-select
        [options]="filters()?.organisations ?? []"
        [ngModel]="selectedOrg()"
        (ngModelChange)="onOrgChange($event)"
        optionLabel="name"
        placeholder="All organisations"
        [showClear]="true"
        [filter]="true"
      />
      <p-select
        [options]="courseOptions()"
        [ngModel]="selectedCourse()"
        (ngModelChange)="selectedCourse.set($event); applyFilters()"
        optionLabel="name"
        placeholder="All courses"
        [showClear]="true"
        [filter]="true"
      >
        <ng-template pTemplate="item" let-course
          >{{ course.name }} · v{{ course.version }}</ng-template
        >
        <ng-template pTemplate="selectedItem" let-course
          >{{ course?.name }} · v{{ course?.version }}</ng-template
        >
      </p-select>
      <p-select
        [options]="teamOptions()"
        [ngModel]="selectedTeam()"
        (ngModelChange)="selectedTeam.set($event); applyFilters()"
        optionLabel="name"
        placeholder="All teams"
        [showClear]="true"
        [filter]="true"
      />
      <p-select
        [options]="userOptions()"
        [ngModel]="selectedUser()"
        (ngModelChange)="selectedUser.set($event); applyFilters()"
        optionLabel="email"
        placeholder="All users"
        [showClear]="true"
        [filter]="true"
        filterBy="email,firstName,lastName"
        (onFilter)="onUserFilter($event)"
      >
        <ng-template pTemplate="item" let-user>{{ userName(user) }} · {{ user.email }}</ng-template>
      </p-select>
      <p-select
        [options]="filters()?.readinessStates ?? []"
        [(ngModel)]="selectedReadiness"
        placeholder="Any readiness"
        [showClear]="true"
        (onChange)="applyFilters()"
      />
      <p-select
        [options]="filters()?.assignmentStatuses ?? []"
        [(ngModel)]="selectedAssignmentStatus"
        placeholder="Any assignment"
        [showClear]="true"
        (onChange)="applyFilters()"
      />
      <p-select
        [options]="filters()?.enrollmentStatuses ?? []"
        [(ngModel)]="selectedEnrollmentStatus"
        placeholder="Any enrollment"
        [showClear]="true"
        (onChange)="applyFilters()"
      />
      <label
        >Attempts from <input type="date" [(ngModel)]="startDate" (change)="applyFilters()"
      /></label>
      <label
        >Attempts to <input type="date" [(ngModel)]="endDate" (change)="applyFilters()"
      /></label>
    </div>
  </p-card>

  @if (error()) {
    <div class="error-state" role="alert">
      <span>Practice course data could not be loaded.</span>
      <p-button label="Try again" icon="pi pi-refresh" [outlined]="true" (onClick)="retry()" />
    </div>
  }
  @if (usersTruncated()) {
    <div class="truncated-warning">
      Showing the first 500 users — type in the user filter to search for a specific user.
    </div>
  }
  @if (freshness()?.status === 'stale') {
    <div class="stale-state" role="status">
      <i class="pi pi-clock"></i>
      Progress is catching up for {{ freshness()!.staleEnrollmentCount }} enrollment{{
        freshness()!.staleEnrollmentCount === 1 ? '' : 's'
      }}.
      @if (freshness()?.sourceGeneratedAt) {
        <span>Last complete snapshot: {{ freshness()!.sourceGeneratedAt | date: 'medium' }}.</span>
      }
      <p-button label="Refresh" icon="pi pi-refresh" [text]="true" (onClick)="retry()" />
    </div>
  } @else if (freshness()?.status === 'unavailable') {
    <div class="unavailable-state" role="status">
      <i class="pi pi-info-circle"></i> Aggregate freshness is unavailable — there is no snapshot
      data to compare against yet.
    </div>
  }

  <p-card>
    <p-table
      [value]="courses()"
      [loading]="loading()"
      [lazy]="true"
      [paginator]="true"
      [rows]="20"
      [first]="first()"
      [totalRecords]="total()"
      (onPage)="first.set($event.first)"
      (onLazyLoad)="load($event)"
      [tableStyle]="{ 'min-width': '70rem' }"
    >
      <ng-template pTemplate="header"
        ><tr>
          <th>Organisation</th>
          <th>Course</th>
          <th>Version</th>
          <th>Status</th>
          <th>Assigned</th>
          <th>Active</th>
          <th>Certified</th>
          <th>Blocked</th>
          <th>Last attempt</th>
          <th></th></tr
      ></ng-template>
      <ng-template pTemplate="body" let-course
        ><tr class="clickable" (click)="open(course)">
          <td>{{ course.organisationName }}</td>
          <td class="font-medium">{{ course.name }}</td>
          <td>v{{ course.version }}</td>
          <td><p-tag [value]="course.status" [severity]="severity(course.status)" /></td>
          <td>{{ course.assignedUsers }}</td>
          <td>{{ course.activeUsers }}</td>
          <td>{{ course.certifiedUsers }}</td>
          <td>{{ course.blockedUsers }}</td>
          <td>{{ course.lastAttemptAt ? (course.lastAttemptAt | date: 'medium') : '—' }}</td>
          <td><i class="pi pi-chevron-right"></i></td></tr
      ></ng-template>
      <ng-template pTemplate="emptymessage"
        ><tr>
          <td colspan="10" class="empty">
            {{
              error()
                ? 'Practice course data could not be loaded.'
                : 'No courses match these filters.'
            }}
          </td>
        </tr></ng-template
      >
    </p-table>
  </p-card>
</div>
